'use client';

import { formatRelativeTime } from '@/shared/utils/formatting';

interface RelativeTimeProps {
  /** ISO timestamp. Empty/null renders the "Not published yet" fallback. */
  iso: string | null | undefined;
  className?: string;
}

/**
 * "2m ago"-style timestamp that is safe to server-render. The label depends
 * on the clock, so the server and the client can legitimately disagree by a
 * minute — `suppressHydrationWarning` tells React that text difference is
 * expected instead of regenerating the tree. The machine-readable value is
 * stable, so `<time dateTime>` keeps the element semantic.
 */
export function RelativeTime({ iso, className }: RelativeTimeProps) {
  const classProp = className ? { className } : {};
  if (!iso) {
    return (
      <span suppressHydrationWarning {...classProp}>
        {formatRelativeTime('')}
      </span>
    );
  }
  return (
    <time dateTime={iso} suppressHydrationWarning {...classProp}>
      {formatRelativeTime(iso)}
    </time>
  );
}
